module.exports = __webpack_public_path__ + "img/404.0929f1ef.png";